<template>
  <v-app id="inspire">
    <!--<v-navigation-drawer
      v-model="drawer"
      app
      color="#353638"
    >
      <v-list dense>

          <v-list-item v-for="item in items" :key="item.title" link :href="item.href" target="_blank" >

                        <v-list-item-action>
                            <i :class="item.icon+' customicon'">&nbsp;</i>
                        </v-list-item-action>

                        <v-list-item-content color="deep-purple accent-4">
                            <v-list-item-title color="deep-purple accent-4">{{ item.title }}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
      </v-list>
    </v-navigation-drawer>-->

    <!--<v-app-bar
      app
      color="primary"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.reservation') }}</v-toolbar-title>


      <v-spacer></v-spacer>

      <v-toolbar-items>

        <v-img
      src="/img/logo.jpg"
      lazy-src="/img/logo.jpg"
      aspect-ratio="1"
      class="grey lighten-2 mt-2"
      max-width="80"
      max-height="40"
    ></v-img>
      </v-toolbar-items>


    </v-app-bar>
-->
    <v-main>
      <v-container
        class=""
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col>
             <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <!--<v-footer
      color="primary"
      app
      class="text-center"
      align="center"
      justify="center"
    >
      <span class="white--text text-center">&copy; 2020</span>
    </v-footer>-->
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    drawer: null,
    items: [
      // { title: 'Zákazníci', icon: 'mdi-phone', url: 'contacts' },
      /*  { title: 'Cenník', icon: 'calendar_today', url: 'calendar' },
            { title: 'Kontakt', icon: 'av_timer', url: 'orders' },
            { title: 'Kalendár', icon: 'calendar_today', url: 'calendar' }, */
    ],
    timeout: 5000,
    // snackBar: false,
  }),
  created() {
    const _this = this;

    /* this.$auth.ready(function () {
                console.log('ready ', _this.$auth.user().email);
            }); */

    // Vue.http.interceptors.push(function (req, next) {
    //     next(function (res) {
    //         if ( ! res.ok) {
    //             _this.$router.push({name: 'error-502'})
    //         }
    //     });
    // });
  },
  methods: {
    closeSnackbar() {
      this.$store.dispatch('RESET_SNACKBAR', false);
    },
  },
  watch: {
    snackBar(v) { // console.log('vvvvvvv',v);
      if (v === false) {
        this.closeSnackbar();
      }
    },
  },
  computed: {
    snackBar() {
      // console.log('crud',this.$store.state.crud.snackBar);
      return this.$store.state.crud.snackBar;
    },
    snackText() {
      return this.$store.state.crud.snackBarText;
    },
    snackColor() {
      return this.$store.state.crud.snackBarColor;
    },
  },
};
</script>

<style scoped>
.v-list-item--active .v-icon {
    color: white;
}
.v-list-item__title {
  color: white;
  &:hover{
    color: $primary;
  }
}


.v-list-item__action .v-icon{
  color: white;
}

.v-list-item--active .v-list-item__title {
    color: white;
    font-weight: 900;
}

</style>
